import React from 'react'
import Menu from '@material-ui/core/Menu'
import RadioGroup from '@material-ui/core/RadioGroup'
import { MEDIA_FILE_FILTERS, EXCLUDE_FILTERS } from '~/enums'
import { MenuOption } from '../../base/MenuSection/MenuSection'
import { useMediaFilter } from '~/hooks/media/useMediaFilter'
import './MediaSort.scss'


export default function MediaFilter({ type, anchorEl, handleClose, value = '', onChange, open }) {
  const { mediaFileFilterByCFG } = useMediaFilter()
  return (
    <Menu
      keepMounted
      getContentAnchorEl={null}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      classes={{
        paper: 'media-sort',
      }}
      open={open}
      onClose={handleClose}
      onClick={handleClose}
    >
      <RadioGroup
        className="media-sort__radio-group"
        value={value}
        onChange={onChange}
        name="sort"
      >
        {Object.entries(mediaFileFilterByCFG).map(([ key, value ], i) => {
          if (EXCLUDE_FILTERS[type]?.includes(MEDIA_FILE_FILTERS[key])) {
            return null
          }
          return (
            <MenuOption
              key={key}
              value={MEDIA_FILE_FILTERS[key]}
              label={value}
              underline={i === 0}
            />
          )
        })}
      </RadioGroup>
    </Menu>
  )
}
